import React from "react";
import { Navigate } from "react-router-dom";
import ChartsCard from "../../Components/Modals/EditCard";
import Blog from "../../Components/blog";
import "./dashboard.css";

const Dashboard = ({ user, isLoggedIn }) => {
  console.log(user);

  return !isLoggedIn ? (
    <Navigate replace to="/login" />
  ) : (
    <div style={{ marginTop: "5%" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="card user-card">
              <div className="card-header">
                <h5>Welcome {user.firstName}!</h5>
              </div>
              <div className="card-block">
                <div className="user-image">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/5/59/User-avatar.svg"
                    className="img-radius"
                    alt="User-Profile-Image"
                  />
                </div>
                <h6 className="f-w-600 m-t-25 m-b-10">
                  {user.firstName} {user.lastName}
                </h6>
                <p className="text-muted">
                  {user.matricNo} | {user.level} Level | {user.email}
                </p>
                <hr />
                <p className="text-muted m-t-15">Session: 2023/2024</p>
                <ul className="list-unstyled activity-leval">
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li></li>
                  <li></li>
                </ul>
                <div className="bg-c-blue counter-block m-t-10 p-20">
                  <div className="row">
                    <div className="col-4">
                      <i className="fa fa-book"></i>
                      <p>{user.matricNo}</p>
                    </div>
                    <div className="col-4">
                      <i className="fa fa-user"></i>
                      <p>{user.level} Level</p>
                    </div>
                    <div className="col-4">
                      <i className="fa fa-hospital-o"></i>
                      <p>Dental Surgery</p>
                    </div>
                  </div>
                </div>
                <p className="m-t-15 text-muted">
                  You've completed the first step. Further information about the
                  election will be passed across.
                </p>
                <hr />
                <div className="row justify-content-center user-social-link">
                  <div className="col-auto">
                    <a href="https://facebook.com/uads.ibadan">
                      <i className="fa fa-facebook text-facebook"></i>
                    </a>
                  </div>
                  <div className="col-auto">
                    <a href="https://twitter.com/ibadandentist">
                      <i className="fa fa-twitter text-twitter"></i>
                    </a>
                  </div>
                  <div className="col-auto">
                    <a href="https://instagram.com/officialuads">
                      <i className="fa fa-instagram text-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-5">
            <ChartsCard
              title=""
              content="Dear Member, thank you for registering! More information about voting, mode of voting  and election guidelines will be passed across in a few days. "
            />
          </div>
        </div>
      </div>
      <Blog />
    </div>
  );
};

export default Dashboard;
